import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraIcon } from '../ensigns/icon';
import { SpecraIconButton } from '../ensigns/icon-button';
import { SpecraInput } from '../ensigns/input';
/** Search input with leading icon and an optional accessible clear action. */ export const SpecraSearchField = /*#__PURE__*/ React.forwardRef(({ 'aria-label': ariaLabel = 'Search', className, clearIcon = '×', clearLabel = 'Clear search', icon, onClear, value, ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            icon ? /*#__PURE__*/ _jsx(SpecraIcon, {
                className: "pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground",
                children: icon
            }) : null,
            /*#__PURE__*/ _jsx(SpecraInput, {
                "aria-label": ariaLabel,
                className: cn(icon && 'pl-8', onClear && value && 'pr-8', className),
                ref: ref,
                type: "search",
                value: value,
                ...props
            }),
            onClear && value ? /*#__PURE__*/ _jsx(SpecraIconButton, {
                className: "absolute right-1 top-1/2 size-6 -translate-y-1/2",
                label: clearLabel,
                onClick: onClear,
                variant: "ghost",
                children: clearIcon
            }) : null
        ]
    }));
SpecraSearchField.displayName = 'SpecraSearchField';
